import React from 'react';
import pkg from 'package.json';
import Head from 'next/head';
import { Button, Icon } from 'semantic-ui-react';
import Control from 'components/molecules/input-control';
import { useAuth } from 'providers/auth';
import { toast } from 'providers/ui';
import getConfig from 'next/config';
const { publicRuntimeConfig } = getConfig();

const { version } = pkg;

// loading the sass style fot the component
import css from './styles.module.scss';
import SignUp from './signup';

/**
 * Organism SplashScreen
 *
* The splash screen, used before loading and opening the system
 */
function SplashScreen (props) {
  const {
    className = '',
    showButton,
    auth,
    fade,
    children,
    ...other
  } = props;

  const {
    signInWithEmail,
    // signUpWithEmail,
    resetPassword
  } = useAuth();

  const frontCardRef = React.useRef();
  const backCardRef = React.useRef();

  const [creatingAccount, setCreatingAccount] = React.useState(false);
  const [email, setEmail] = React.useState("");
  const [pwd, setPwd] = React.useState("");
  const [alternativeContent, setAlternativeContent] = React.useState(null);
  const [authenticating, setAuthenticating] = React.useState(false);
  const [reseting, setReseting] = React.useState(false);

  async function signInWithEmailForm () {
    setAuthenticating(true);
    if (!email || !pwd) {
      console.log(toast.POSITION);
      toast.error("You have to type your e-mail and password first", {
        position: toast.POSITION?.TOP_LEFT,
        autoClose: true,
        closeButton: true
      });
      setAuthenticating(false);
      return;
    }

    const { error } = await signInWithEmail(email, pwd);

    if (error) {
      toast.error((
        <>
          Invalid credentials.<br/>
          {error.message || error.error_description}
        </>), {
        position: toast.POSITION.TOP_CENTER,
        closeButton: true
      });
      return setAuthenticating(false);
    }
    setTimeout(_ => {
      setAuthenticating(false);
    }, 5000);
  }

  async function resetPasswordForm (event) {
    if (!email) {
      toast.error("You have to type your e-mail first", {
        position: toast.POSITION?.TOP_CENTER,
        autoClose: true,
        closeButton: true
      });
      return;
    }
    setReseting(true);
    const { error } = await resetPassword(email);

    if (error) {
      console.error(error);
    }
    setReseting(false);

    const userMail = email;
    const domain = 'https://' + userMail.split('@')[1];

    setAlternativeContent(<>
      An e-mail was sent with a link for you to<br />
      follow the instructions and reset your password.<br/>
      Access your <a href={domain}>{userMail}</a> and follow
      the instructions.<br/>
    </>);
  }

  return (
    <div
      className={`${css['organism__splash-screen-container']} ${className}`}
      {...other}
      data-fading={fade ? 1 : null}
    >
      <Head>
        <title>amos+</title>
      </Head>
      <div className={css['glass-effects-container']} />
      <div className={css['glass-effects-container-copy']} />

      <div className={css['content-container']} data-content-wrapper="true">
        <div className={css['header']}>
          <img src="/favicon.png" alt="amos+" />
          <div>
            amos+
            <br />
            <h3>Advanced Management Operational System</h3>
            <br />
          </div>

          {
            // !creatingAccount && !authenticating && !reseting && !fade &&  (
            (authenticating || reseting || creatingAccount) && (
              <div className={css['loader']} />
            )
          }
        </div>

        <div
          className={css["flip-card"]}
          data-flipped={creatingAccount ? 1 : null}
        >
          <div className={css["flip-card-inner"]}>
            <div className={css["flip-card-front"]} ref={frontCardRef}>
              <div className={`${css['enter-button-container']} ${css['loading-container']}`}>
                {alternativeContent}
                {
                  showButton && !alternativeContent && <>
                    <div className={css["input-container"]}>
                      <Control
                        // fluid
                        type="email"
                        // label={'E-mail'}
                        placeholder="E-mail"
                        // disabled={loadingAddr}
                        // size='mini'
                        // asObject
                        data-testid="signin-email"
                        onChange={event => setEmail(event.target.value)}
                        value={email || ""}
                        width={2}
                        tabIndex={1}
                        disabled={!!reseting || !!authenticating}
                      />
                      <div className={css["password-container"]}>
                        <Control
                          // fluid
                          type="password"
                          placeholder={'Password'}
                          onChange={event => setPwd(event.target.value)}
                          value={pwd || ""}
                          width={2}
                          tabIndex={2}
                          data-testid="signin-pwd"
                          disabled={!!reseting || !!authenticating}
                        />
                        <div className={css["forgot-container"]}>
                          Forgot your password? No problem,&nbsp;
                          <Button
                            basic
                            onClick={resetPasswordForm}
                            className={css["forgot-button"]}
                            loading={!!reseting}
                            disabled={!!reseting || !!authenticating}
                            tabIndex={4}
                          >
                            reset your password
                          </Button>
                        </div>
                      </div>

                      <Button
                        // size="large"
                        color="blue"
                        disabled={!!reseting}
                        loading={!!authenticating}
                        style={{whiteSpace: 'nowrap'}}
                        data-testid="signin-btn"
                        tabIndex={3}
                        onClick={(_) => {
                          signInWithEmailForm();
                        }}
                      >
                        {
                          !authenticating && !reseting && (
                            <>
                              <Icon name="lock open" />
                              Sign in
                            </>
                          )
                        }
                      </Button>
                    </div>
                    {
                      publicRuntimeConfig.DISABLE_REGISTRATION ||
                      (publicRuntimeConfig.REGISTRATION_CONSTRAINT || "")
                        .toUpperCase() === 'NONE'
                        ? null
                        : (
                          <div className={css["create-container"]}>
                            <span>Don't have an account?&nbsp;</span>
                            <Button
                              // color='green'
                              className={css['sign-in-button']}
                              basic
                              disabled={!!reseting || !!authenticating}
                              tabIndex={5}
                              onClick={(_) => {
                                setCreatingAccount(true);
                                setTimeout(_ => {
                                  backCardRef.current
                                    .querySelector('input').focus();
                                }, 200);
                              }}
                            >
                              Sign up
                            </Button>
                            {/* <Button
                              color='green'
                              disabled={!!reseting || !!authenticating}
                              tabIndex={5}
                              onClick={(_) => {
                                setCreatingAccount(true);
                                setTimeout(_ => {
                                  backCardRef.current
                                    .querySelector('input').focus();
                                }, 200);
                              }}
                            >
                              <Icon name="add user" />
                              Create an account
                            </Button> */}
                          </div>
                        )
                    }
                  </>
                }
              </div>
            </div>
            {
              publicRuntimeConfig.DISABLE_REGISTRATION ||
              (publicRuntimeConfig.REGISTRATION_CONSTRAINT || "")
                .toUpperCase() === 'NONE'
                ? null
                : (
                  <div className={css["flip-card-back"]} ref={backCardRef}>
                    {alternativeContent}
                    <div className={css["input-container"]}>
                      <SignUp
                        onCancel={_ => {
                          setCreatingAccount(false);
                          setTimeout(_ => {
                            frontCardRef.current.querySelector('input').focus();
                          }, 200);
                        }}
                      />
                    </div>
                  </div>
                )
            }
          </div>
        </div>
      </div>
      <div className={css['version-container']}>
        v{version}
        <br />
        Development:{' '}
        <a href="https://dex01.com.br/" target="blank">
          DEx01 Technology by design
        </a>
      </div>
      {children}
    </div>
  );
}

export default SplashScreen;
